import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { notification, Form, Input, Button } from 'antd';
import Header from '@components/Comman/Header';
// @ts-ignore
import ApiClient from '../../api-client/apiClient';
// @ts-ignore
import { apiUrl, PORT, version } from '../../environment';
// @ts-ignore
import { getAccessToken } from '../../auth';
import { platformNameRules, platformUrlRules, redirectUrlsRules, contactEmailRules, contactPersonRules } from '../../utils/comman';

const PlatformRegistration = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const user = useSelector((state: any) => state.Auth.user);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const token = `Bearer ${getAccessToken()}`;
            const url = `${apiUrl}${PORT}${version}/platform/register`;
            const payload = {
                ...values,
                redirectURLs: values.redirectURLs.split(',').map((url: string) => url.trim()),
                roleId: user?.user?.roleId || user?.data?.roleId,
            };

            const response = await ApiClient.post(url, payload, token);

            if (response.status === 200 || response.status === 201) {
                notification.success({ message: response.message || 'Platform registered successfully!' });
                form.resetFields();
            } else {
                console.error('Registration failed:', response);
                notification.error({ message: response.message || 'Error registering platform.' });
            }
        } catch (error) {
            console.error('An error occurred during platform registration:', error);
            notification.error({ message: 'An unexpected error occurred.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header 
                pagTitle="Platform Registration" 
                breadcrumb={[
                    { title: 'Platform List', href: '/super-admin/platform-list' },
                    { title: 'Platform Registration' }
                ]}
            />
            <div className="contentBody">
                <div className="bodycard">
                    <div className="cardContentbody">
                        <Form form={form} layout="vertical" onFinish={handleSubmit}>
                            <Form.Item label="Platform Name" name="platformName" rules={platformNameRules}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Platform URL" name="platformURL" rules={platformUrlRules}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Redirect URLs (comma-separated)" name="redirectURLs" rules={redirectUrlsRules}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Contact Email" name="contactEmail" rules={contactEmailRules}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Contact Person" name="contactPerson" rules={contactPersonRules}>
                                <Input />
                            </Form.Item>
                            <Form.Item>
                                <Button htmlType="submit" loading={loading} style={{
                                    backgroundColor: '#F47523',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    padding: '6px 15px',
                                    fontSize: '14px',
                                    height: 'auto'
                                }}>Register</Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlatformRegistration;
